export default function () {

  $(document).on('ready', function() {

    $('.card.product').hover(function() {
      var thisCard = $(this);
      if(thisCard.find('.product__out-of-stock').length > 0) {
        setTimeout(function() {
          thisCard.find('.product__out-of-stock-waitlist').toggleClass('active');
        }, 300);
      }
    });

	});
}



// WEBPACK FOOTER //
// ./scripts/components/SetupOutOfStock.js